import { render, staticRenderFns } from "./dishGroupManage.vue?vue&type=template&id=6bc601bc&scoped=true"
import script from "./dishGroupManage.vue?vue&type=script&lang=js"
export * from "./dishGroupManage.vue?vue&type=script&lang=js"
import style0 from "./dishGroupManage.vue?vue&type=style&index=0&id=6bc601bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc601bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc601bc')) {
      api.createRecord('6bc601bc', component.options)
    } else {
      api.reload('6bc601bc', component.options)
    }
    module.hot.accept("./dishGroupManage.vue?vue&type=template&id=6bc601bc&scoped=true", function () {
      api.rerender('6bc601bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/dishGroupManage/dishGroupManage.vue"
export default component.exports